/* eslint-disable no-param-reassign, max-len, no-case-declarations, no-prototype-builtins */

import { toast } from 'react-toastify';
import $ from 'jquery';

import moment from 'moment-timezone';
import Constants from './Constants';
import SessionHelper from './SessionHelper';
import TranslationHelper from './TranslationHelper';

// eslint-disable-next-line
Number.prototype.toFixedNoRounding = function(fixed) {
	fixed = fixed || 0;
	// eslint-disable-next-line no-restricted-properties
	fixed = Math.pow(10, fixed);
	return Math.floor(this * fixed) / fixed;
};

const LOCALE_CURRENCY = new Map([
	['AU', 'AUD'],
	['AUS', 'AUD'],
	['IT', 'EUR'],
	['ITA', 'EUR'],
	['US', 'USD'],
	['JP', 'YEN'],
	['CA', 'CAD'],
	['CAN', 'CAD'],
]);

const dateFormatter = new Intl.DateTimeFormat(navigator.language, {
	year: 'numeric',
	month: 'long',
	timeZone: 'UTC',
});

const longDateFormatter = new Intl.DateTimeFormat(navigator.language, {
	day: 'numeric',
	month: 'long',
	year: 'numeric',
	timeZone: 'UTC',
});

const datePickerFormatter = new Intl.DateTimeFormat(navigator.language, {
	day: 'numeric',
	month: 'numeric',
	year: 'numeric',
	timeZone: 'UTC',
});

export default class UIHelper {
	static currencyFormatter = (dollarSign) => {
		// eslint-disable-next-line no-nested-ternary
		let locale = navigator.languages && navigator.languages[0]
			? navigator.languages[0]
			: navigator.language
				? navigator.language
				:			SessionHelper.getSupportedCountry();

		let currency = 'CAD';

		if (locale && locale.length && !locale.includes('-')) {
			const finalString = UIHelper.getLocaleFromCountryCode(locale);
			locale = finalString || locale;
		}
		if (!dollarSign && locale.includes('-')) {
			currency = LOCALE_CURRENCY.get(locale.substring(locale.indexOf('-') + 1).toUpperCase());
		} else {
			currency = dollarSign ? dollarSign.toUpperCase() : 'CAD';
		}

		if (!currency) {
			currency = dollarSign ? dollarSign.toUpperCase() : 'CAD';
		}

		return new Intl.NumberFormat(locale, {
			style: 'currency',
			currency,
			minimumFractionDigits: 2
		});
	}

	static getCurrency = () => LOCALE_CURRENCY.get(SessionHelper.getSupportedCountry().toUpperCase())

	static getLocaleFromCountryCode(countryCode) {
		const locales = {
			DE: 'de-DE',
			FR: 'fr-FR',
			IT: 'it-IT',
			ITA: 'it-IT',
			JA: 'ja-JP',
			JP: 'ja-JP',
			JPN: 'ja-JP',
			AU: 'en-AU',
			AUS: 'en-AU',
			CA: 'en-CA',
			CAN: 'en-CA',
		};
		return locales[countryCode.toUpperCase()];
	}

	static minutesToHHMM(mins, twentyFour = false) {
		let h = Math.floor(mins / 60);
		let m = mins % 60;
		m = m < 10 ? `0${m}` : m;

		if (twentyFour) {
			h = h < 10 ? `0${h}` : h;
			return `${h}:${m}`;
		}
		let a = 'am';
		if (h >= 12) a = 'pm';
		if (h > 12) h -= 12;
		return `${h}:${m} ${a}`;
	}

	static formatDate = (date) => (date ? dateFormatter.format(new Date(date)) : date);

	static formatLongDate = (date) => (date ? longDateFormatter.format(new Date(date)) : date);

	static formatMomentLongDate = (date, timezone) => (date ? moment.tz(date, timezone).format('MMMM D, YYYY') : date);

	static formatDateForPicker = (date) => (date ? datePickerFormatter.format(new Date(date)) : date);

	static getLocaleDateString() {
		const formats = {
			'ar-SA': 'DD/MM/YY',
			'bg-BG': 'DD.M.YYYY',
			'ca-ES': 'DD/MM/YYYY',
			'zh-TW': 'YYYY/M/D',
			'cs-CZ': 'D.M.YYYY',
			'da-DK': 'DD-MM-YYYY',
			'de-DE': 'DD.MM.YYYY',
			de: 'DD.MM.YYYY',
			'el-GR': 'D/M/YYYY',
			en: 'MM/DD/YYYY',
			'fi-FI': 'D.M.YYYY',
			'fr-FR': 'DD/MM/YYYY',
			'he-IL': 'DD/MM/YYYY',
			'hu-HU': 'YYYY. MM. DD.',
			'is-IS': 'D.M.YYYY',
			it: 'DD/MM/YYYY',
			'it-IT': 'DD/MM/YYYY',
			'it-it': 'DD/MM/YYYY',
			'ja-JP': 'YYYY/MM/DD',
			ja: 'YYYY/MM/DD',
			'ko-KR': 'YYYY-MM-DD',
			'nl-NL': 'D-M-YYYY',
			'nb-NO': 'DD.MM.YYYY',
			'pl-PL': 'YYYY-MM-DD',
			'pt-BR': 'D/M/YYYY',
			'ro-RO': 'DD.MM.YYYY',
			'ru-RU': 'DD.MM.YYYY',
			'hr-HR': 'D.M.YYYY',
			'sk-SK': 'D. M. YYYY',
			'sq-AL': 'YYYY-MM-DD',
			'sv-SE': 'YYYY-MM-DD',
			'th-TH': 'D/M/YYYY',
			'tr-TR': 'DD.MM.YYYY',
			'ur-PK': 'DD/MM/YYYY',
			'id-ID': 'DD/MM/YYYY',
			'uk-UA': 'DD.MM.YYYY',
			'be-BY': 'DD.MM.YYYY',
			'sl-SI': 'D.M.YYYY',
			'et-EE': 'D.MM.YYYY',
			'lv-LV': 'YYYY.MM.DD.',
			'lt-LT': 'YYYY.MM.DD',
			'fa-IR': 'MM/DD/YYYY',
			'vi-VN': 'DD/MM/YYYY',
			'hy-AM': 'DD.MM.YYYY',
			'az-Latn-AZ': 'DD.MM.YYYY',
			'eu-ES': 'YYYY/MM/DD',
			'mk-MK': 'DD.MM.YYYY',
			'af-ZA': 'YYYY/MM/DD',
			'ka-GE': 'DD.MM.YYYY',
			'fo-FO': 'DD-MM-YYYY',
			'hi-IN': 'DD-MM-YYYY',
			'ms-MY': 'DD/MM/YYYY',
			'kk-KZ': 'DD.MM.YYYY',
			'ky-KG': 'DD.MM.YY',
			'sw-KE': 'M/D/YYYY',
			'uz-Latn-UZ': 'DD/MM YYYY',
			'tt-RU': 'DD.MM.YYYY',
			'pa-IN': 'DD-MM-YY',
			'gu-IN': 'DD-MM-YY',
			'ta-IN': 'DD-MM-YYYY',
			'te-IN': 'DD-MM-YY',
			'kn-IN': 'DD-MM-YY',
			'mr-IN': 'DD-MM-YYYY',
			'sa-IN': 'DD-MM-YYYY',
			'mn-MN': 'YY.MM.DD',
			'gl-ES': 'DD/MM/YY',
			'kok-IN': 'DD-MM-YYYY',
			'syr-SY': 'DD/MM/YYYY',
			'dv-MV': 'DD/MM/YY',
			'ar-IQ': 'DD/MM/YYYY',
			'zh-CN': 'YYYY/M/D',
			'de-CH': 'DD.MM.YYYY',
			'en-GB': 'DD/MM/YYYY',
			'es-MX': 'DD/MM/YYYY',
			'fr-BE': 'D/MM/YYYY',
			'it-CH': 'DD.MM.YYYY',
			'nl-BE': 'D/MM/YYYY',
			'nn-NO': 'DD.MM.YYYY',
			'pt-PT': 'DD-MM-YYYY',
			'sr-Latn-CS': 'D.M.YYYY',
			'sv-FI': 'D.M.YYYY',
			'az-Cyrl-AZ': 'DD.MM.YYYY',
			'ms-BN': 'DD/MM/YYYY',
			'uz-Cyrl-UZ': 'DD.MM.YYYY',
			'ar-EG': 'DD/MM/YYYY',
			'zh-HK': 'D/M/YYYY',
			'de-AT': 'DD.MM.YYYY',
			'en-AU': 'DD/MM/YYYY',
			'es-ES': 'DD/MM/YYYY',
			'fr-CA': 'YYYY-MM-DD',
			'sr-Cyrl-CS': 'D.M.YYYY',
			'ar-LY': 'DD/MM/YYYY',
			'zh-SG': 'D/M/YYYY',
			'de-LU': 'DD.MM.YYYY',
			'en-CA': 'MM/DD/YYYY',
			'es-GT': 'DD/MM/YYYY',
			'fr-CH': 'DD.MM.YYYY',
			'ar-DZ': 'DD-MM-YYYY',
			'zh-MO': 'D/M/YYYY',
			'de-LI': 'DD.MM.YYYY',
			'en-NZ': 'D/MM/YYYY',
			'es-CR': 'DD/MM/YYYY',
			'fr-LU': 'DD/MM/YYYY',
			'ar-MA': 'DD-MM-YYYY',
			'en-IE': 'DD/MM/YYYY',
			'es-PA': 'MM/DD/YYYY',
			'fr-MC': 'DD/MM/YYYY',
			'ar-TN': 'DD-MM-YYYY',
			'en-ZA': 'YYYY/MM/DD',
			'es-DO': 'DD/MM/YYYY',
			'ar-OM': 'DD/MM/YYYY',
			'en-JM': 'DD/MM/YYYY',
			'es-VE': 'DD/MM/YYYY',
			'ar-YE': 'DD/MM/YYYY',
			'en-029': 'MM/DD/YYYY',
			'es-CO': 'DD/MM/YYYY',
			'ar-SY': 'DD/MM/YYYY',
			'en-BZ': 'DD/MM/YYYY',
			'es-PE': 'DD/MM/YYYY',
			'ar-JO': 'DD/MM/YYYY',
			'en-TT': 'DD/MM/YYYY',
			'es-AR': 'DD/MM/YYYY',
			'ar-LB': 'DD/MM/YYYY',
			'en-ZW': 'M/D/YYYY',
			'es-EC': 'DD/MM/YYYY',
			'ar-KW': 'DD/MM/YYYY',
			'en-PH': 'M/D/YYYY',
			'es-CL': 'DD-MM-YYYY',
			'ar-AE': 'DD/MM/YYYY',
			'es-UY': 'DD/MM/YYYY',
			'ar-BH': 'DD/MM/YYYY',
			'es-PY': 'DD/MM/YYYY',
			'ar-QA': 'DD/MM/YYYY',
			'es-BO': 'DD/MM/YYYY',
			'es-SV': 'DD/MM/YYYY',
			'es-HN': 'DD/MM/YYYY',
			'es-NI': 'DD/MM/YYYY',
			'es-PR': 'DD/MM/YYYY',
			'am-ET': 'D/M/YYYY',
			'tzm-Latn-DZ': 'DD-MM-YYYY',
			'iu-Latn-CA': 'D/MM/YYYY',
			'sma-NO': 'DD.MM.YYYY',
			'mn-Mong-CN': 'YYYY/M/D',
			'gd-GB': 'DD/MM/YYYY',
			'en-MY': 'D/M/YYYY',
			'prs-AF': 'DD/MM/YY',
			'bn-BD': 'DD-MM-YY',
			'wo-SN': 'DD/MM/YYYY',
			'rw-RW': 'M/D/YYYY',
			'qut-GT': 'DD/MM/YYYY',
			'sah-RU': 'MM.DD.YYYY',
			'gsw-FR': 'DD/MM/YYYY',
			'co-FR': 'DD/MM/YYYY',
			'oc-FR': 'DD/MM/YYYY',
			'mi-NZ': 'DD/MM/YYYY',
			'ga-IE': 'DD/MM/YYYY',
			'se-SE': 'YYYY-MM-DD',
			'br-FR': 'DD/MM/YYYY',
			'smn-FI': 'D.M.YYYY',
			'moh-CA': 'M/D/YYYY',
			'arn-CL': 'DD-MM-YYYY',
			'ii-CN': 'YYYY/M/D',
			'dsb-DE': 'D. M. YYYY',
			'ig-NG': 'D/M/YYYY',
			'kl-GL': 'DD-MM-YYYY',
			'lb-LU': 'DD/MM/YYYY',
			'ba-RU': 'DD.MM.YY',
			'nso-ZA': 'YYYY/MM/DD',
			'quz-BO': 'DD/MM/YYYY',
			'yo-NG': 'D/M/YYYY',
			'ha-Latn-NG': 'D/M/YYYY',
			'fil-PH': 'M/D/YYYY',
			'ps-AF': 'DD/MM/YY',
			'fy-NL': 'D-M-YYYY',
			'ne-NP': 'M/D/YYYY',
			'se-NO': 'DD.MM.YYYY',
			'iu-Cans-CA': 'D/M/YYYY',
			'sr-Latn-RS': 'D.M.YYYY',
			'si-LK': 'YYYY-MM-DD',
			'sr-Cyrl-RS': 'D.M.YYYY',
			'lo-LA': 'DD/MM/YYYY',
			'km-KH': 'YYYY-MM-DD',
			'cy-GB': 'DD/MM/YYYY',
			'bo-CN': 'YYYY/M/D',
			'sms-FI': 'D.M.YYYY',
			'as-IN': 'DD-MM-YYYY',
			'ml-IN': 'DD-MM-YY',
			'en-IN': 'DD-MM-YYYY',
			'or-IN': 'DD-MM-YY',
			'bn-IN': 'DD-MM-YY',
			'tk-TM': 'DD.MM.YY',
			'bs-Latn-BA': 'D.M.YYYY',
			'mt-MT': 'DD/MM/YYYY',
			'sr-Cyrl-ME': 'D.M.YYYY',
			'se-FI': 'D.M.YYYY',
			'zu-ZA': 'YYYY/MM/DD',
			'xh-ZA': 'YYYY/MM/DD',
			'tn-ZA': 'YYYY/MM/DD',
			'hsb-DE': 'D. M. YYYY',
			'bs-Cyrl-BA': 'D.M.YYYY',
			'tg-Cyrl-TJ': 'DD.MM.YY',
			'sr-Latn-BA': 'D.M.YYYY',
			'smj-NO': 'DD.MM.YYYY',
			'rm-CH': 'DD/MM/YYYY',
			'smj-SE': 'YYYY-MM-DD',
			'quz-EC': 'DD/MM/YYYY',
			'quz-PE': 'DD/MM/YYYY',
			'hr-BA': 'D.M.YYYY.',
			'sr-Latn-ME': 'D.M.YYYY',
			'sma-SE': 'YYYY-MM-DD',
			'en-SG': 'D/M/YYYY',
			'ug-CN': 'YYYY-M-D',
			'sr-Cyrl-BA': 'D.M.YYYY',
			'es-US': 'M/D/YYYY'
		};

		return formats[navigator.language] || 'MM/DD/YYYY';
	}

	static showPage(that, pathname, state) {
		that.context.router.history.push({
			pathname,
			state,
		});
	}

	static showPageReplace(that, pathname, state) {
		that.context.router.history.replace({
			pathname,
			state,
		});
	}

	static savePageForAuthentication(pathname, param) {
		SessionHelper.setLocalStorageObject(Constants.SAVED_PAGE, { pathname, param });
	}

	static showSavedPageAfterAuthentication(that) {
		const obj = SessionHelper.getLocalStorageObject(Constants.SAVED_PAGE);
		if (obj && obj.pathname) {
			// SessionHelper.removeLocalStorageItem(Constants.SAVED_PAGE);
			UIHelper.showPage(that, obj.pathname, obj.param);
		} else {
			window.location = '/';
		}
	}

	static showSavedPageAfterAuthenticationForRF(props) {
		const obj = SessionHelper.getLocalStorageObject(Constants.SAVED_PAGE);
		if (obj && obj.pathname) {
			props.history.push({
				pathname: obj.pathname,
				state: obj.param
			});
			window.location.reload();
		} else {
			window.location = '/';
		}
	}

	static showErrorMessage(message) {
		toast.error(message, { autoClose: 5000 });
	}

	static showInfoMessage(message) {
		toast.info(message, { autoClose: 5000 });
	}

	static showSuccessMessage(message) {
		toast.success(message, { autoClose: 5000 });
	}

	static showReloadServiceWorker(message, callback) {
		toast.info(message, { autoClose: false, closeButton: true, onClose: callback });
	}

	// we have to change the logic in the sitemap builder in Public/batch when this will change
	static getSeoUrl(url) {
		if (url) {
			let encodedUrl = url.toString().toLowerCase();
			encodedUrl = encodedUrl.split(/&+/).join('-and-');
			encodedUrl = encodedUrl.split(/[^a-z0-9]/).join('-');
			encodedUrl = encodedUrl.split(/-+/).join('-');
			encodedUrl = encodedUrl.trim('-');
			return encodedUrl;
		}
		return null;
	}

	static mobileWindowCheck() {
		return !!window.matchMedia('only screen and (max-width: 760px)').matches;
	}

	static getSellerNameInSearch({ sellerPersonalName, sellerCompanyName }, showCompany) {
		if (showCompany === 'true' && sellerCompanyName) {
			return sellerCompanyName;
		} if (showCompany === 'combined' && sellerCompanyName) {
			return `${sellerPersonalName} from ${sellerCompanyName}`;
		}
		return sellerPersonalName;
	}

	static getSellerName(seller, showCompany) {
		const { personal, company } = seller;
		const serviceOrPersonalName = [personal.firstName, personal.lastName];

		if (showCompany === 'true' && company && company.hasOwnProperty('name')) {
			return company.name;
		} if (showCompany === 'combined' && company && company.hasOwnProperty('name')) {
			return `${serviceOrPersonalName[0]}${serviceOrPersonalName[1] ? ` ${serviceOrPersonalName[1]}` : ''} from ${company.name}`;
		}
		return `${serviceOrPersonalName[0]} ${serviceOrPersonalName[1] ? serviceOrPersonalName[1] : ''}`;
	}

	static getSellerAddress({ personal, company }) {
		return company && company.address && Object.keys(company.address).length
			? `${company.address.street}, ${company.address.city}, ${company.address.state}, ${company.address.country} - ${company.address.zip}`
			: `${personal.address.street}, ${personal.address.city}, ${personal.address.state}, ${personal.address.country} - ${personal.address.zip}`;
	}

	static getSellerPhone({ personal, company }) {
		return company && company.phone
			? company.phone
			:			personal.phone;
	}

	static getSellerEmail({ personal, company }) {
		return company && company.email
			? company.email
			:			personal.email;
	}

	static getToPos(selector) {
		const element = selector[0] === '#'
			? document.getElementById(selector.slice(1))
			:			document.getElementsByClassName(selector)[0];
		setTimeout(() => {
			window.scrollTo({ top: element.offsetTop - 50, left: 0, behavior: 'smooth' });
		}, 300);
	}

	static elementInViewport(elem) {
		const selectedElement = $(elem);
		if (selectedElement && selectedElement.length) {
			const docViewTop = $(window).scrollTop();
			const docViewBottom = docViewTop + $(window).height();
			const elemTop = selectedElement.offset().top;
			return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
		}
		return false;
	}

	static showUnitOfPrice(uop) {
		if (!uop) return null;
		const unit = uop.toLowerCase();
		switch (unit) {
		case 'per booking time':
			return TranslationHelper.getValue('customer_account.productOrder.hours');
		case 'per day':
			return TranslationHelper.getValue('customer_account.productOrder.days');
		default:
			const showUnit = uop.split(' ');
			if (showUnit[0].toLowerCase() === 'per') {
				showUnit.shift();
			}
			const finalUnit = showUnit.join(' ');

			return finalUnit;
		}
	}

	static getUrlParameter(customAttributes) {
		const params = new URLSearchParams(document.location.search.substring(1));
		const search = params.get('search');
		const city = params.get('city');
		const loginRequired = params.get('showlogin');
		const location = params.get('location');
		const category = params.get('category');
		const startDate = params.get('startDate');
		const endDate = params.get('endDate');
		const postSearchToken = params.get('postSearchToken');
		const customParams = {};
		// eslint-disable-next-line array-callback-return
		customAttributes.map((attr) => {
			const val = params.get(attr.uniqueName.toLowerCase());
			if (val) {
				const filed = `${attr.section}.${attr.uniqueName}`;
				customParams[filed] = attr.attributeType === 'Multi_Picklist' ? {
					isChanged: true,
					name: attr.uniqueName,
					type: attr.attributeType,
					searchValue: [{ value: val, label: val }],
				} : val;
			}
		});

		return {
			search,
			city,
			loginRequired,
			location,
			category,
			startDate,
			endDate,
			postSearchToken,
			customParams
		};
	}

	static isValidUrl(string) {
		try {
			// eslint-disable-next-line no-new
			new URL(string);
			return true;
		} catch (error) {
			return false;
		}
	}

	static toTitleCase(string) {
		const text = string.replace(/_/g, ' ');
		return text.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
	}

	static randomString(stringLength) {
		const alphaNumeric = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		let rando = '';
		let index = 0;
		while (index < stringLength) {
			rando += alphaNumeric[Math.floor(Math.random() * alphaNumeric.length)];
			// eslint-disable-next-line no-plusplus
			index++;
		}
		return rando;
	}

	static getTimezoneName(timezone) {
		const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
		let timezoneName = moment.tz(timezone || defaultTimezone).zoneAbbr();

		// check if the timezone is number or not
		// https://github.com/moment/moment-timezone/issues/477
		// https://github.com/moment/moment-timezone/issues/780
		if (Number.isInteger(parseInt(timezoneName, 10))) {
			const array = timezone.split('/');
			timezoneName = array[array.length - 1].replace('_', ' ');
		}
		return timezoneName;
	}

	// customers don't need to know if orders status is "paid out" or "ready for payout"
	// these status should be just 'completed'
	static convertOrderStatusForCustomer(status) {
		return ['Completed', 'PaidOut', 'Ready For Payout'].includes(status) ? TranslationHelper.getValue('customer_account.viewOrderDetails.completed') : status;
	}
}
